import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';

class UserProfileSearchStore extends BaseStore {
  constructor() {
    super('user-profile-searches', 'user-profile-searches', { site_model: true });
  }

  async testProfile(search, showInactives) {
    const params = { search, showInactives }
    params.site_id = this.getCurrentSiteID()
    const { data } = await HttpClient.post(`${config.api}/user-profile-searches/test-profile`, params)
    return data
  }
}

export default new UserProfileSearchStore();
